export async function submitBrief(payload) {
  try {
    const endpoint = import.meta.env.VITE_BRIEF_ENDPOINT;
    if (endpoint) {
      // Payload REST expects interests as [{item: "..."}] objects,
      // but the funnel sends flat strings. Normalize here.
      const normalized = {
        ...payload,
        interests: (payload.interests || []).map((item) => ({ item })),
      };
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(normalized),
      });
      return { ok: res.ok, simulated: false };
    }
    return { ok: false, simulated: true };
  } catch (err) {
    return { ok: false, simulated: false, error: String(err) };
  }
}

export function getCheckoutUrl() {
  return import.meta.env.VITE_CHECKOUT_URL || null;
}
